// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/banner-mid-page-full-width-item/banner-mid-page-full-width-item.component.scss
// module id = 434
// module chunks = 0